export const PDF_VIEWER_MESSAGE_TYPES = {
  PDF_VIEWER_READY: 'PDF_VIEWER_READY',
  PDF_VIEWER_CONTENT: 'PDF_VIEWER_CONTENT'
} as const;

export type PdfViewerMessageType =
  (typeof PDF_VIEWER_MESSAGE_TYPES)[keyof typeof PDF_VIEWER_MESSAGE_TYPES];

export type PdfViewerReadyMessage = {
  type: typeof PDF_VIEWER_MESSAGE_TYPES.PDF_VIEWER_READY;
};

export type PdfViewerContentMessage = {
  type: typeof PDF_VIEWER_MESSAGE_TYPES.PDF_VIEWER_CONTENT;
  pdfContent: string;
};

export type PdfViewerMessage = PdfViewerReadyMessage | PdfViewerContentMessage;

export function isPdfViewerReadyMessage(
  data: unknown
): data is PdfViewerReadyMessage {
  return (
    typeof data === 'object' &&
    data !== null &&
    (data as { type?: unknown }).type ===
      PDF_VIEWER_MESSAGE_TYPES.PDF_VIEWER_READY
  );
}

export function isPdfViewerContentMessage(
  data: unknown
): data is PdfViewerContentMessage {
  if (typeof data !== 'object' || data === null) {
    return false;
  }

  const message = data as { type?: unknown; pdfContent?: unknown };
  return (
    message.type === PDF_VIEWER_MESSAGE_TYPES.PDF_VIEWER_CONTENT &&
    typeof message.pdfContent === 'string' &&
    message.pdfContent.length > 0
  );
}
